import { Typewriter } from './Typewriter';
export default Typewriter;
